import { render } from "./jin-index.vue?vue&type=template&id=6c7913ff&scoped=true"
import script from "./jin-index.vue?vue&type=script&lang=js"
export * from "./jin-index.vue?vue&type=script&lang=js"

import "./jin-index.vue?vue&type=style&index=0&id=6c7913ff&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7913ff"]])

export default __exports__